<section class="py-20">
  <div class="centered-fullwidth grid grid-cols-1 gap-y-10 desk:grid-cols-2">
    <div class="flex flex-col justify-center gap-y-5 px-5 desk:pl-0">
      @if (data.title; as title) {
        <app-title [title]="title" class="desk:w-[435px]" size="h2" />
      }
      @if (data.reviewStats; as reviewStats) {
        <div class="-mx-5 pb-5 pt-2 desk:pb-8">
          <div class="flex items-center justify-center desk:ml-2.5 desk:justify-start">
            <app-review-badge [reviewStats]="reviewStats" />
          </div>
        </div>
      }
      @if (data.buttonAvis; as buttonAvis) {
        <app-button (onButtonClick)="openGoogleReviewsPopup()" [label]="buttonAvis" />
      }
      @if (data.cta; as cta) {
        <app-button [label]="cta.label" [url]="cta.url" />
      }
    </div>
    <div class="relative ml-5 flex justify-end desk:pl-0">
      <div class="mask-blob-cut-ratio-0_698 desk:mask-blob-ratio-1_278 group size-full">
        @if (data.image; as image) {
          <app-image
            [hoverEffect]="true"
            [image]="image"
            [isPriority]="!isImageInPreviousBlocks"
            [pregenerationSize]="{ width: 520, height: 530 }" />
        }
        @if (data.testimonial; as testimonial) {
          <a
            [routerLink]="testimonial.url"
            class="absolute inset-0 flex size-full flex-col justify-end bg-black/25 py-[70px] pl-[40px] pr-[45px] text-white desk:py-[50px] desk:pl-[30px] desk:pr-[150px]">
            <div class="mb-[12px] flex opacity-60">
              <app-svg [height]="64" [inline]="true" [width]="50" src="assets/icons/quote.svg" />
            </div>
            <span>{{ testimonial.text }}</span>
            <span class="mt-[30px] flex gap-x-4 font-bold text-white desk:pb-7">
              {{ testimonial.author }}
              <app-svg
                [height]="24"
                [inline]="true"
                [width]="24"
                class="text-white"
                src="assets/icons/arrow-right.svg" />
            </span>
          </a>
        }
      </div>
    </div>
  </div>
</section>
